import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { SEO_SOCIALS_IMAGE } from './constants';

const getAlternateLanguages = (possibleLanguages, fullUrl) => {
  const url = new URL(fullUrl);
  let host = url.host;
  host = host.substr(host.indexOf('.') + 1);
  const altLangs = possibleLanguages
    .map(item => item.key)
    .map(lang => {
      return {
        lang,
        url: createLangUrl(url.protocol, host, url.pathname, lang),
      };
    });
  altLangs.push({
    lang: 'x-default',
    url: createLangUrl(url.protocol, host, url.pathname, 'en'),
  });
  return altLangs;
};

const createLangUrl = (protocol, host, path, lang) => {
  let url = protocol + '//';
  url += lang === 'en' ? 'www.' : lang + '.';
  url += host;
  url += path;
  return url;
};

const creatQueryString = searchParams => {
  let qs = '?';
  for (const key of searchParams.keys()) {
    qs += `${key}=${searchParams.get(key)}&`;
  }
  return qs.slice(0, -1);
};

const getPrevNextLinks = (fullUrl, page, pageCount) => {
  const links = [];
  const url = new URL(fullUrl);
  const searchParams = url.searchParams;
  if (page > 1) {
    searchParams.set('page', page - 1);
    links.push({
      rel: 'prev',
      href: `${url.protocol}//${url.host}${url.pathname}${creatQueryString(
        searchParams,
      )}`,
    });
  }
  if (page < pageCount) {
    searchParams.set('page', page + 1);
    links.push({
      rel: 'next',
      href: `${url.protocol}//${url.host}${url.pathname}${creatQueryString(
        searchParams,
      )}`,
    });
  }
  return links;
};

const getCanonical = fullUrl => {
  const location = new URL(fullUrl);
  return location.protocol + '//' + location.host + location.pathname;
};

const getSearcParams = fullUrl => {
  const location = new URL(fullUrl);
  return location.search;
};

export const generateHelmet = ({
  possibleLanguages,
  url,
  title,
  description,
  meta,
  link,
  page,
  pageCount,
  socialsImage = SEO_SOCIALS_IMAGE,
}) => {
  const canonical = getCanonical(url);
  const hasSearcParams = getSearcParams(url) !== '';
  // console.log(`seo = ${JSON.stringify(seo)}`)
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={`${description}`} />
      {hasSearcParams && <meta name="robots" content="nofollow" />}
      <meta name="twitter:account_id" content="6608082" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@Wix" />
      <meta name="twitter:image:src" content={`${socialsImage}`} />
      <meta property="fb:app_id" content="236335823061286" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={`${title}`} />
      <meta property="og:description" content={`${description}`} />
      <meta property="og:url" content={`${canonical}`} />
      <meta property="og:site_name" content="Wix.com" />
      <meta property="og:image" content={`${socialsImage}`} />
      {meta &&
        meta.length > 0 &&
        meta.map(metaParts => (
          <meta
            key={`${metaParts.name}`}
            name={`${metaParts.name}`}
            content={`${metaParts.content}`}
          />
        ))}
      <link
        type="image/png"
        href="//www.wix.com/favicon.ico"
        rel="shortcut icon"
      />
      <link rel="canonical" href={`${canonical}`} />
      {getAlternateLanguages(possibleLanguages, canonical).map(altLang => (
        <link
          key={`${altLang.lang}`}
          rel="alternate"
          hreflang={`${altLang.lang}`}
          href={`${altLang.url}`}
        />
      ))}
      {(page || pageCount) &&
        getPrevNextLinks(url, page, pageCount).map(linkParts => (
          <link
            key={`${linkParts.rel}`}
            rel={`${linkParts.rel}`}
            href={`${linkParts.href}`}
          />
        ))}
      {link &&
        link.length > 0 &&
        link.map(linkParts => (
          <link
            key={`${linkParts.rel}`}
            rel={`${linkParts.rel}`}
            href={`${linkParts.href}`}
          />
        ))}
    </Helmet>
  );
};
